import { ReactNode, useCallback } from "react"

import { Collapse, IconButton } from "@mui/material"

import { HelpOutlineRoundedIcon } from "@l2r-front/l2r-icons"

import * as Styled from "./InfoItemButton.styled"

type InfoItemButtonProps = {
    children?: ReactNode[]
    className?: string
    id?: string
    disabled?: boolean
    endAdornments?: ReactNode
    icon?: React.ElementType
    isOpen?: boolean
    label: string
    onClick?: () => void
    selected?: boolean
    tooltipText?: string
}

export const InfoItemButton = (props: InfoItemButtonProps) => {

    const {
        children,
        className,
        id = "",
        disabled,
        endAdornments,
        icon,
        isOpen,
        label,
        onClick,
        selected = false,
        tooltipText,
    } = props

    const Icon = icon

    const displayList = !!(isOpen && children?.length)

    const onButtonClick = useCallback(() => {
        if (!disabled) {
            if (onClick) {
                onClick()
            }
        }
    }, [disabled, onClick])

    return (
        <div>
            <Styled.ListItemButton
                className={className}
                disableRipple={disabled}
                id={id}
                isDisabled={disabled}
                isSelected={!disabled && selected}
                onClick={onButtonClick}>
                {Icon ? <Icon color="common/black_states" /> : null}
                <Styled.Label
                    isDisabled={disabled}
                    id="info-item-name"
                    hasPaddingLeft={!!icon}
                    isSelected={selected}>
                    {label}
                </Styled.Label>
                {tooltipText &&
                    <Styled.Tooltip disableFocusListener title={tooltipText}>
                        <IconButton color="action/active light">
                            <HelpOutlineRoundedIcon />
                        </IconButton>
                    </Styled.Tooltip>
                }
                {endAdornments}
                {!!children?.length && !disabled && <Styled.ArrowIcon color="action/disabled" isOpen={isOpen} />}
            </Styled.ListItemButton>
            <Collapse in={displayList}>
                <Styled.List disablePadding>
                    {children}
                </Styled.List>
            </Collapse>
        </div>
    )
}
